import { APPLICATION_ROLE_GRAD_PLAN_ASSOCIATE_PREFIX, APPLICATION_ROLE_GRAD_PLAN_ADMIN_PREFIX, APPLICATION_ROLE_GRAD_FACULTY_PREFIX,
    APPLICATION_ROLE_GRADUATE_APPROVER_PREFIX, SYSTEM_ROLE } from "../util/constants";

export function buildGraduationDeadlineMap(graduationDeadlines = []) {
    const graduationDeadlineMap = {};
    for(const graduationDeadline of graduationDeadlines) {
        const deadlines = graduationDeadline.deadlines.map((deadline) => ({ primary: deadline.name, secondary: deadline.date }));
        graduationDeadlineMap[graduationDeadline.termCode] = deadlines;
    }
    return graduationDeadlineMap;
}

export function buildSystemRoles(applicationRoles = []) {
    const buildSystemRole = (name, program = null, plan = null) => ({ name, program, plan });

    const systemRoles = [];
    for(const applicationRole of applicationRoles) {
        if(applicationRole.includes("#")) {
            const tokens = applicationRole.split("#");
            const applicationRolePrefix = `${tokens[0]}#`;
            const name = (SYSTEM_ROLE[applicationRolePrefix] ?? "");
            let plan = null;
            let program = null;
            if([APPLICATION_ROLE_GRAD_PLAN_ASSOCIATE_PREFIX, APPLICATION_ROLE_GRAD_PLAN_ADMIN_PREFIX].includes(applicationRolePrefix)) plan = tokens[1];
            if([APPLICATION_ROLE_GRAD_FACULTY_PREFIX, APPLICATION_ROLE_GRADUATE_APPROVER_PREFIX].includes(applicationRolePrefix)) program = tokens[1];
            systemRoles.push(buildSystemRole(name, program, plan));
        } else {
            const name = (SYSTEM_ROLE[applicationRole] ?? "");
            systemRoles.push(buildSystemRole(name));
        }
    }
    return systemRoles;
}